import React from 'react'
import styled from 'styled-components'
import { FaAngleLeft } from "react-icons/fa";
import SidebarSubMenuItem from './SidebarSubMenuItem';
import { NolKoma7to1rem } from '../../GlobalStyles';

export const TopSubMenu = styled.div`
    display: flex;
    align-items: center;
    background-color: black;
    color: white;
    height: 3rem;
    cursor: pointer;
    padding: 0 5px;
    & > svg {
        margin-right: 10px;
        font-size: 1rem;
    }
    p {
        text-transform: uppercase;
        font-size: ${NolKoma7to1rem};
    }
`
export const SubMenuList = styled.div`
    margin-top: 2rem;
    display: grid;
    gap: 1.2rem;
    padding: 0 10px;
`

export default function SidebarSubMenu({ judul, subMenuList, toggleSubMenu, toggleSidebar }) {
  return (
      <>
        <TopSubMenu onClick={toggleSubMenu}>
            <FaAngleLeft/>
            <p>{judul}</p>
        </TopSubMenu>
        <SubMenuList>
            {
                subMenuList && subMenuList.map((subMenu, idx) => (
                    <SidebarSubMenuItem key={idx} subMenu={subMenu} toggleSidebar={toggleSidebar} />
                ))
            }
        </SubMenuList>
      </>
  )
}
        // <SubMenuList>
        //     {
        //         subNavList.map((sub, idx) => (
        //             <div key={idx}>
        //                 <SubMenuItem onClick={subMenuOnClick}>
        //                     <Left>
        //                         {sub.icon}
        //                         <p>{sub.title}</p>
        //                     </Left>
        //                     <Right>
        //                         <FaAngleRight/>
        //                     </Right>
        //                     {JSON.stringify(sub.subSubNav)}
        //                 </SubMenuItem>
        //             </div>
        //         ))
        //     }
        // </SubMenuList>

// {/* <SubAnakSubWrapper subnyaSubNav={subnyaSubNav}>
//     <>
//         <TopSubMenu onClick={toggleSubnyaSubNav}>
//             <FaAngleLeft/>
//             <h4>{sub.title}</h4>
//         </TopSubMenu>
//         <SubMenuList>
//             {
//                 sub.subSubNav.map((anak, idx) => (
//                     <div key={idx}>
//                         {anak.title}
//                     </div>
//                 ))
//             }
//         </SubMenuList>
//     </>
// </SubAnakSubWrapper> */}